import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import cx from 'clsx'
import Mustache from 'mustache'
import { useState } from 'react'

import { renderSkill } from './Answer/Skill'

import { QuestionnaireMessages, SkillApi } from './index'

interface QuestionnaireProps {
  className?: string
  cardId: string
  messages: QuestionnaireMessages
  wordsQuestionnaire?: {
    yesButtonLabel?: string | null
    noButtonLabel?: string | null
  } | null
  operatorEscalationUrl: string
  skillApi: SkillApi
  onFeedback: (action: 'yes' | 'no', callback: () => void) => void
}
export function Questionnaire({
  cardId,
  messages,
  wordsQuestionnaire,
  operatorEscalationUrl,
  skillApi,
  onFeedback,
}: QuestionnaireProps) {
  const [state, setState] = useState<'notSelected' | 'yes' | 'no'>('notSelected')

  const feedback = (action: 'yes' | 'no') => {
    onFeedback(action, () => setState(action))
  }

  return (
    <Card className={cx('faq-questionnaire', state)}>
      <CardContent>
        <Typography<any>
          className="faq-questionnaire__title"
          color="textSecondary"
          align="left"
          gutterBottom
          component="div"
          dangerouslySetInnerHTML={{
            __html: Mustache.render(messages[state], { operatorEscalationUrl }),
          }}
        />
        {state === 'yes'
          ? renderSkill(skillApi, {
              from: 'FAQ_FEEDBACK_YES',
              text: messages.yesForm,
              cardId,
            })
          : state === 'no'
            ? renderSkill(skillApi, {
                from: 'FAQ_FEEDBACK_NO',
                text: messages.noForm,
                cardId,
              })
            : null}
      </CardContent>

      {state !== 'notSelected' ? null : (
        <CardActions className={cx('faq-actions', 'faq-questionnaire__actions')}>
          <Button
            className={cx(
              'faq-button',
              'faq-questionnaire__actions__button',
              'faq-questionnaire__actions__button--yes'
            )}
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => feedback('yes')}
          >
            {wordsQuestionnaire?.yesButtonLabel || 'はい'}
          </Button>
          <Button
            className={cx(
              'faq-button',
              'faq-questionnaire__actions__button',
              'faq-questionnaire__actions__button--no'
            )}
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => feedback('no')}
          >
            {wordsQuestionnaire?.noButtonLabel || 'いいえ'}
          </Button>
        </CardActions>
      )}
    </Card>
  )
}
